export default "__VITE_ASSET__D1a0Aurd__"